import Timer from 'helpers/setTimer';
import actions from 'redux/actions';

let timer = new Timer();
const middlewareProcess = (response, store) => {
  const { config, status } = response || {};
  const urlAPI = config?.url || '';

  const hasError = !!response?.data?.error;

  const endpoints = [
    'mergeGroups',
    'splitGroup',
    'removeGroups',
    'releaseDidNow',
    'releaseDidNowByDeliveryRate',
    'releaseDidNowByClickRate',
    'bulkPurchase',
    'buyByBatch',
    'filterSuppressionGroups',
    'dataCertingGroup',
    'number/scrubDid',
    'unarchiveGroup',
    'exportServlet',
  ];

  if (urlAPI) {
    const isOpenProcess = endpoints.some((endpoint) =>
      urlAPI.toLowerCase().includes(endpoint.toLowerCase())
    );

    if (status >= 200 && status <= 299 && isOpenProcess && !hasError) {
      timer.debounce(() => {
        store.dispatch(actions.toggleProcess({ open: true }));
      }, 200);
    }
  }

  //* Create spintax
  // if (urlAPI.includes('create-spintax')) {
  //   if (response?.data?.code === 200) {
  //     timer.debounce(() => {
  //       store.dispatch(actions.toggleProcess({ open: true }));
  //     }, 200);
  //   }
  // }
};

export default middlewareProcess;
